import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { ProtocolsMenu } from "@/sites/protocols/protocols/protocols-menu";
import { columns } from "@/sites/protocols/protocols/table-config";
import type { ProtocolPanelBaseProps } from "../shared";

/** Props Interface */
interface ProtocolRelatedProps extends ProtocolPanelBaseProps {
	projectId: string;
}

export function ProtocolRelated({ protocolId, projectId }: ProtocolRelatedProps) {
	/** Query */
	const {
		data: protocols,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: ["protocols", projectId, "related", protocolId],
		queryFn: async () => {
			const response = await client.protocols.index.$get({
				query: { projectId },
			});
			const data = await responseHandler(response);
			const list = data.protocols;
			return list.filter((item) => item.id !== protocolId);
		},
	});

	/** Render */
	return (
		<DataTable
			data={protocols}
			columns={columns}
			isLoading={isLoading}
			persistenceKey="protocol-related-table"
			refetch={refetch}
			queryKey={queryKey}
			menu={<ProtocolsMenu createQueryString={`?projectId=${projectId}`} />}
		/>
	);
}
